import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import ServicesSection from './components/ServicesSection';
import IntegrationsSection from './components/IntegrationsSection';
import ProcessSection from './components/ProcessSection';
import IndustriesSection from './components/IndustriesSection';
import TestimonialsSection from './components/TestimonialsSection';

export default function Home() {
  return (
    <div className="font-inter bg-brand-bg min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <ServicesSection />
        <IntegrationsSection />
        <ProcessSection />
        <IndustriesSection />
        <TestimonialsSection />
      </main>
      <Footer />
    </div>
  );
}
